import { Helmet } from 'react-helmet-async';
import OrganizationVisitSettings from 'src/sections/@dashboard/organization/components/OrganizationVisitSettings/OrganizationVisitSettings';

export default function OrganizationVisitSettingsPage() {
  return (
    <>
      <Helmet>
        <title>Ustawienia wizyt | Vetsi</title>
      </Helmet>
      <OrganizationVisitSettings />
    </>
  );
}
